import AccordionHtml from './rfct/html/accordion-html';
import LinkListHtml from './rfct/html/link-list-html';
import moduleRegistry from './rfct/module-registry/module-registry';


// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const categoryConfig = {
    selectors: {
        resultList: '.catalog__cards-aoe',
        lightbox: '.single-lightbox',
    },
};

function init() {
    $(categoryConfig.selectors.resultList).each((i, el) => {
        const $searchResultList = $(el);
        initAoe($searchResultList);
    });

    if ($(categoryConfig.selectors.lightbox).length > 0) {
        initLightbox(jQuery(categoryConfig.selectors.lightbox));
    }
}

// init logic
function initLightbox($lightbox) {
    $lightbox.imageLightbox({
        button: true,
        overlay: true,
        animationSpeed: 250,
        quitOnImgClick: true,
        caption: true,
    });

    // initializeLightboxes();
}

function initAoe($searchResultList) {
    const $params = new URLSearchParams(window.location.search);
    const $categoryID = !isNaN($params.get('cat')) ? $params.get('cat') : '';

    const apiURL = `${$globalConfig.urls.getRecursiveCategories}?category=${$categoryID}`;
    jQuery.ajax({
        type: 'GET',
        url: apiURL,
        processData: false,
        dataType: 'json',
        success(data) {
            const indicationAccordionItems = [];
            const categoryAccordionItems = [];
            let indicationTitle = '';
            let categoryTitle = '';

            data.children.forEach((mainCategory) => {
                if (mainCategory.hasChildren) {
                    mainCategory.children.forEach((category) => {
                        const categories = [];
                        category.children.forEach((subCategory) => {
                            // eslint-disable-next-line max-len
                            const subCategoryBaseUrl = subCategory.hasChildren ? $globalConfig.urls.categoryHtml : $globalConfig.urls.searchHtml;
                            const indicationUrl = `${subCategoryBaseUrl}?cat=${subCategory.identifier}`;
                            categories.push({ title: subCategory.name, link: indicationUrl });
                        });
                        // eslint-disable-next-line max-len
                        const categoryBaseUrl = category.hasChildren ? $globalConfig.urls.categoryHtml : $globalConfig.urls.searchHtml;
                        categories.push({ title: $globalConfig.textResources.productCatalogConnectorConfig.categoryPageLinkText, link: `${categoryBaseUrl}?cat=${category.identifier}` });

                        const categoryHtml = new LinkListHtml(categories).toString();

                        if (category.categoryType === 'p') {
                            indicationTitle = mainCategory.name;
                            // eslint-disable-next-line max-len
                            indicationAccordionItems.push({ title: category.name, content: categoryHtml });
                        } else if (category.categoryType === 'c') {
                            categoryTitle = mainCategory.name;
                            // eslint-disable-next-line max-len
                            categoryAccordionItems.push({ title: category.name, content: categoryHtml });
                        }
                    });
                }
            });

            const multiple = true;
            // eslint-disable-next-line max-len
            const indicationAccordionHtml = new AccordionHtml(indicationAccordionItems, multiple).toString();
            // eslint-disable-next-line max-len
            const categoryAccordionHtml = new AccordionHtml(categoryAccordionItems, multiple).toString();

            let html = '';

            if (indicationAccordionItems.length > 0) {
                html += `<div class="col-lg-4">
                    <div class="rfct-textblock">
                        <h2 class="mb-3">${indicationTitle}</h2>
                    </div>
                    ${indicationAccordionHtml}
                </div>`;
            }
            if (categoryAccordionItems.length > 0) {
                html += `<div class="${indicationAccordionItems.length > 0 ? 'offset-lg-1 ' : ''}col-lg-4">
                    <div class="rfct-textblock">
                        <h2 class="mb-3">${categoryTitle}</h2>
                    </div>
                    ${categoryAccordionHtml}
                </div>`;
            }

            if (html !== '') {
                moduleRegistry.insertHTML($searchResultList, html);
            }

            // eslint-disable-next-line no-undef
            const myLazyLoad = new LazyLoad();
            myLazyLoad.update();
            // eslint-disable-next-line no-undef
            picturefill();
        },
        error() {
            // eslint-disable-next-line no-console
            // console.log('Error loading aoe result!');
        },
    });
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
